<template>
  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.school") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.school_name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.branch") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.branch_name }}
          </dd>
        </div>

        <!-- <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('programme.academicyear') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ programme.academic_year_name }}
            </dd>
          </div> -->

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.code") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.code }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.name") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.description") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.description }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.startdate") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.start_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.enddate") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.end_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.file_name") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            <p
              class="cursor-pointer text-blue-600 underline"
              @click="
                download(
                  programme.file_name,
                  '/download-programme',
                  programme.id
                )
              "
              :title="programme.file_name"
            >
              {{ programme.file_name }}
            </p>
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.created_by") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.created_by }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.updated_by") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.updated_by }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.created_at") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.created_at }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("programme.updated_at") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ programme.updated_at }}
          </dd>
        </div>
      </dl>
      <ul class="flex justify-center items-center my-4">
        <div v-for="(tab, index) in tabs" :key="index">
          <li
            class="cursor-pointer py-2 px-4 text-gray-500 border-b-8"
            :class="
              activeTab === tab.index ? 'text-green-500 border-green-500' : ''
            "
            @click="activeTab = tab.index"
            v-text="tab.name"
          ></li>
        </div>
      </ul>
      <!-- <div class="flex gap-4 justify-center border-t p-4">
        <button
          class="py-2 px-4 border rounded-md border-blue-600 text-blue-600 cursor-pointer uppercase text-sm font-bold hover:bg-blue-500 hover:text-white hover:shadow"
          @click="activeTab--"
          v-if="activeTab > 0"
        >
          Back
        </button>
        <button
          class="py-2 px-4 border rounded-md border-blue-600 text-blue-600 cursor-pointer uppercase text-sm font-bold hover:bg-blue-500 hover:text-white hover:shadow"
          @click="activeTab++"
          v-if="activeTab < tabs.length - 1"
        >
          Next
        </button>
      </div> -->
      <div v-show="activeTab === 0">
        <main-section>
          <programme-committe
            :propClass="programme"
            :programmeId="programme.id"
          />
        </main-section>
      </div>
      <div v-show="activeTab === 1">
        <main-section>
          <programme-owner :propClass="programme" :programmeId="programme.id" />
        </main-section>
      </div>
      <div v-show="activeTab === 2">
        <main-section>
          <programme-exception-time
            :propClass="programme"
            :programmeId="programme.id"
          />
        </main-section>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from "vue";
import axios from "axios";
import ProgrammeCommitte from "@/views/humanresource/programmeCommitte/Index.vue";
import ProgrammeOwner from "@/views/humanresource/programmeOwner/Index.vue";
import ProgrammeExceptionTime from "@/views/humanresource/programmeexceptiontime/Index.vue";
import { useToast } from "vue-toastification";
import { axiosDocument } from "@/boot/axios";
export default {
  name: "Programme Detail Form",
  components: {
    ProgrammeCommitte,
    ProgrammeOwner,
    ProgrammeExceptionTime,
  },
  props: {
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propObject: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);
    const activeTab = ref(0);
    const toast = useToast();

    const programme = reactive({
      id: "",
      school_id: "",
      branch_id: "",
      academic_year_id: "",
      code: "",
      name: "",
      description: "",
      start_date: "",
      end_date: "",
      file_name: "",
      created_by: "",
      created_at: "",
    });

    const download = (name, url, id) => {
      const params = { filename: name, id };

      axios
        .get(url, { params, responseType: "blob" })
        .then((response) => {
          triggerDownload(response.data, name);
        })
        .catch((error) => {
          console.error("Primary download failed:", error);
          // toast.error('Download failed: ' + (error.response?.data?.message || error.message))

          // Fallback
          downloadDoc(name, id);
        });
    };

    const downloadDoc = (name, id) => {
      const params = { filename: name, id };

      axiosDocument
        .get("/download-programme", { params, responseType: "blob" })
        .then((response) => {
          triggerDownload(response.data, name);
        })
        .catch((error) => {
          console.error("Fallback download failed:", error);
          toast.error(
            "Fallback failed: " +
              (error.response?.data?.message || error.message)
          );
        });
    };

    const triggerDownload = (blobData, filename) => {
      const fileURL = window.URL.createObjectURL(new Blob([blobData]));
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
      window.URL.revokeObjectURL(fileURL);
    };

    watchEffect(() => {
      const newprogramme = props.propObject;
      Object.assign(programme, newprogramme);
    });

    return {
      titleStack,
      programme,
      download,
      downloadDoc,
      tabs: [
        {
          index: 0,
          name: "Committee",
        },
        {
          index: 1,
          name: "Programme Owner",
        },
        {
          index: 2,
          name: "Exception Time",
        },
      ],
      activeTab,
    };
  },
};
</script>
